var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-badge-info",style:({ backgroundColor: _vm.hex2rgba(_vm.getColorByRiskLevel(_vm.value), 0.1) })},[_c('GlRiskBadge',{attrs:{"value":_vm.value}}),(_vm.$slots.text)?_c('div',{staticClass:"gl-badge-info__text"},[_vm._t("text")],2):_c('div',{staticClass:"gl-badge-info__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }